
export function isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export const anonymize = (input: string): string => {
    if (input.length >= 2) {
        return input.charAt(0) + "*".repeat(input.length - 1);
    }
    return input;
};

export function anonymizeEmail(email: string): string {
    const [localPart, domain] = email.split("@");
    const [domainName, ...rest] = domain ? domain.split(".") : [""];
    
    if (localPart && domain) {
        return `${anonymize(localPart)}@${anonymize(domainName)}${rest.length ? '.' + rest.join('.') : ''}`;
    }
    return email;
};

export function getUserName(
    firstname: string,
    lastname: string,
    pseudo: string,
    isStreamOn: boolean
): string {
    if (firstname && lastname) {
        return isStreamOn
            ? `${firstname} ${anonymize(lastname)}`
            : `${firstname} ${lastname}`;
    } else {
        return isStreamOn ? anonymize(pseudo) : pseudo;
    }
}

